import { HEXCOLOR_INQUIRY_STATUS, INQUIRY_STATUS } from "helpers/constans";
import { formatDateStringToKorea, getPlatFormImage } from "helpers/format";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import { Card, Col, Label, Row } from "reactstrap";
import NO_IMAGE_USER from "../../../../assets/images/no-user.png";
import ModalPreview from "components/Common/ModalPreview";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import { capitalizeFirstLetter, secondsToDhms } from "utils";
import { Button, Dropdown, Menu } from "antd";
import { toast } from "react-toastify";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import inquiryListApi from "api/inquiryListApi";
import CopyWrapper from "components/Common/CopyWrapper";
import ProfileIcon from "../../../../assets/images/profile.png";
import ContactIcon from "../../../../assets/images/phone-icon.png";
import countries from "helpers/countries";
import { DownOutlined } from "@ant-design/icons";
import { Rate } from "antd";

const Overview = ({ data, reloadData, dataInquiryTypes }: any) => {
  const { t, i18n } = useTranslation();
  const [linkImage, setLinkImage] = useState<any>(null);

  const countryCode = data?.countryCode;
  const country = countries.find((item) => item?.code == countryCode) || {
    name_korea: data?.device_info?.country,
    name: data?.device_info?.country,
    flags: "",
  };

  useEffect(() => {
    document.title = `${t("Overview")} - ${t("Inquiry Detail")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  let platform = data?.user?.profile?.provider || "email";
  let imgPlatform = getPlatFormImage(platform);
  if (platform === "default") {
    platform = "Email";
  }

  async function handleUpdateInquiry(value: any) {
    if (value == data?.status) return;
    try {
      const response: any = await inquiryListApi?.updateInquiry(data?.id, {
        status: value,
      });
      console.log(response);
      if (response?.code == 200) {
        reloadData();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response?.message}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }

  let inquiryStatusCondition = [...INQUIRY_STATUS];
  if (data?.status == 2)
    inquiryStatusCondition = [
      INQUIRY_STATUS[1],
      INQUIRY_STATUS[2],
      INQUIRY_STATUS[3],
    ];
  if (data?.status == 3)
    inquiryStatusCondition = [INQUIRY_STATUS[2], INQUIRY_STATUS[3]];

  const menu = (
    <Menu onClick={(e) => handleUpdateInquiry(Number(e.key))}>
      {inquiryStatusCondition.map((status) => (
        <Menu.Item key={status?.value}>{t(status?.label)}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <React.Fragment>
      <div className="mt-3">
        <Row>
          <div className="d-flex gap-5 align-items-center">
            <div className="mb-3 d-flex gap-3">
              <Label htmlFor="name-bar" className="form-label m-0">
                {t("Inquiry Type")}
              </Label>
              <div>
                <span className={`rounded-pill badge bg-primary`}>
                  {data?.inquiryType?.name}
                </span>
              </div>
            </div>

            <div className="mb-3 d-flex gap-3 align-items-center">
              <Label htmlFor="name-bar" className="form-label m-0">
                {t("Inquiry Status")}
              </Label>
              <div>
                <Dropdown overlay={menu} trigger={["click"]}>
                  <Button
                    style={{
                      backgroundColor: HEXCOLOR_INQUIRY_STATUS[data?.status],
                      color: "white",
                      borderRadius: "25px",
                      padding: "6px 16px",
                    }}
                    disabled={data?.status == 1 || data?.status == 4}
                  >
                    {t(
                      INQUIRY_STATUS?.find(
                        (i: any) => String(i?.value) === String(data?.status)
                      )?.label || ""
                    )}
                    {data?.status != 1 && data?.status != 4 && <DownOutlined />}
                  </Button>
                </Dropdown>

                {/* <Select
                  value={INQUIRY_STATUS?.find(
                    (i: any) => String(i?.value) === String(data?.status)
                  )}
                  style={{ width: 120 }}
                  onChange={handleUpdateInquiry}
                  options={INQUIRY_STATUS}
                  dropdownStyle={{ borderRadius: "8px" }}
                /> */}
              </div>

              <div style={{ fontSize: 11 }}>
                {!data?.processingTimeExpired && data?.processTimeElapsed && (
                  <>{t("Timelapsed")} </>
                )}
                {data?.processingTimeExpired && data?.processTimeElapsed && (
                  <>{t("Overdue")} </>
                )}
                {secondsToDhms(
                  data?.processingTimeExpired || data?.processTimeElapsed,
                  t
                )}
              </div>
            </div>

            <div className="mb-3 d-flex gap-3">
              <Label htmlFor="name-bar" className="form-label m-0">
                {t("Inquiry Date")}
              </Label>
              <div>
                {formatDateStringToKorea(data?.createdAt, "YYYY-MM-DD HH:mm") ||
                  "-"}
              </div>
            </div>
          </div>

          <Col lg={12}>
            <div className="mb-3">
              <Label htmlFor="name-bar" className="form-label m-0">
                {t("Content")}
              </Label>
              <div style={{ whiteSpace: "pre-line" }}>
                {data?.contents ? (
                  <CopyWrapper
                    contentCopy={data?.contents}
                  >{`${data?.contents}`}</CopyWrapper>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </Col>

          <div className="d-flex gap-4 flex-wrap">
            <Card
              className="p-3"
              style={{ minWidth: 300, background: "#F7F7F7" }}
            >
              <h5 className="mb-3 d-flex align-items-center gap-2">
                <img src={ProfileIcon} alt="profile" /> {t("Account")}
              </h5>
              <div>
                <div className="mb-3 d-flex gap-3 align-items-center">
                  <div className="text-center ">
                    <div
                      className="cursor-pointer"
                      onClick={() =>
                        setLinkImage(
                          (prev: any) =>
                            data?.user?.profile?.avatar ?? NO_IMAGE_USER
                        )
                      }
                    >
                      <img
                        src={data?.user?.profile?.avatar ?? NO_IMAGE_USER}
                        className="rounded-circle avatar-sm"
                        alt="thumbnail"
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null; // prevents looping
                          currentTarget.src = NO_IMAGE_USER;
                        }}
                      />
                    </div>
                  </div>

                  <div>
                    <div className="mb-1" style={{ fontWeight: 700 }}>
                      {data?.user?.profile?.nickname ? (
                        <CopyWrapper
                          contentCopy={data?.user?.profile?.nickname}
                        >{`${data?.user?.profile?.nickname}`}</CopyWrapper>
                      ) : (
                        "-"
                      )}
                    </div>

                    <div style={{ color: "#555555" }}>
                      {data?.user?.profile?.email ? (
                        <CopyWrapper
                          contentCopy={data?.user?.profile?.email}
                        >{`${data?.user?.profile?.email}`}</CopyWrapper>
                      ) : (
                        "-"
                      )}
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-5">
                  <div>
                    <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("Platform")}:
                      </Label>
                      <div className="d-flex flex-column gap-1">
                        <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                          <div style={{ width: "25px" }}>
                            {imgPlatform && platform !== "-" && (
                              <img
                                src={imgPlatform}
                                width={25}
                                height={25}
                                alt="platform"
                              />
                            )}
                          </div>
                          <div className="cursor-pointer">
                            {t(capitalizeFirstLetter(platform))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("IP")}:
                      </Label>
                      <div>
                        {data?.ipAddress ? (
                          <CopyWrapper
                            contentCopy={data?.ipAddress}
                          >{`${data?.ipAddress}`}</CopyWrapper>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>{" "}
                    <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("Country")}:
                      </Label>
                      <div className="cursor-pointer d-flex gap-2 align-items-center justify-content-center">
                        {country && (
                          <>
                            {countryCode && (
                              <img
                                src={country?.flags}
                                width={20}
                                height={20}
                                alt="profile"
                              />
                            )}
                            <div className="cursor-pointer">
                              {i18n?.language === "ko"
                                ? country?.name_korea
                                : country?.name}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <div>
                    {/* <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("Model")}:
                      </Label>
                      <div>
                        {data?.deviceModel ? (
                          <CopyWrapper
                            contentCopy={data?.deviceModel}
                          >{`${data?.deviceModel}`}</CopyWrapper>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                    <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("Manufacturer")}:
                      </Label>
                      <div>
                        {data?.deviceManufacturer ? (
                          <CopyWrapper
                            contentCopy={data?.deviceManufacturer}
                          >{`${data?.deviceManufacturer}`}</CopyWrapper>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div> */}

                    <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("App Version")}:
                      </Label>
                      <div>
                        {data?.appVersion ? (
                          <CopyWrapper
                            contentCopy={data?.appVersion}
                          >{`${data?.appVersion}`}</CopyWrapper>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>

                    <div className="mb-3 d-flex gap-2 align-items-center">
                      <Label htmlFor="name-bar" className="form-label m-0">
                        {t("UUID")}:
                      </Label>
                      <div>
                        {data?.uuid ? (
                          <CopyWrapper
                            contentCopy={data?.uuid}
                          >{`${data?.uuid}`}</CopyWrapper>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mb-3 d-flex gap-2 align-items-center">
                  <Label htmlFor="name-bar" className="form-label m-0">
                    {t("Address")}:
                  </Label>
                  <div>
                    {data?.address ? (
                      <CopyWrapper
                        contentCopy={data?.address}
                      >{`${data?.address}`}</CopyWrapper>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </div>
            </Card>
            <div>
              <Card
                className="p-3"
                style={{
                  minWidth: 300,
                  background: "#F7F7F7",
                  height: "fit-content",
                }}
              >
                <h5 className="mb-3 d-flex align-items-center gap-2">
                  <img src={ContactIcon} alt="contact" />
                  {t("Contact")}
                </h5>

                <div className="mb-3 d-flex gap-2 align-items-center">
                  <Label htmlFor="name-bar" className="form-label m-0">
                    {t("Contact Name")}:
                  </Label>
                  <div>
                    {data?.contactName ? (
                      <CopyWrapper
                        contentCopy={data?.contactName}
                      >{`${data?.contactName}`}</CopyWrapper>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
                <div className="mb-3 d-flex gap-2 align-items-center">
                  <Label htmlFor="name-bar" className="form-label m-0">
                    {t("Contact Phone")}:
                  </Label>
                  <div>
                    {data?.contactPhone ? (
                      <CopyWrapper
                        contentCopy={data?.contactPhone}
                      >{`${data?.contactPhone}`}</CopyWrapper>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
                <div className="mb-3 d-flex gap-2 align-items-center">
                  <Label htmlFor="name-bar" className="form-label m-0">
                    {t("Contact Email")}:
                  </Label>
                  <div>
                    {data?.contactEmail ? (
                      <CopyWrapper
                        contentCopy={data?.contactEmail}
                      >{`${data?.contactEmail}`}</CopyWrapper>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </Card>
              {data?.rating && (
                <Card
                  className="p-3"
                  style={{
                    minWidth: 300,
                    background: "#F7F7F7",
                    height: "fit-content",
                  }}
                >
                  <h5 className="mb-3">{t("Rating")}</h5>

                  <div className="mb-3 d-flex gap-2 align-items-center">
                    <div>
                      {data?.rating ? (
                        <Rate value={data?.rating} disabled />
                      ) : (
                        "-"
                      )}
                    </div>
                  </div>
                  {/* <div className="mb-3 d-flex gap-2 align-items-center">
                    <Label htmlFor="name-bar" className="form-label m-0">
                      {t("Rating Date")}
                    </Label>
                    <div>{data?.rating_date || "-"}</div>
                  </div> */}
                  <div className="mb-3 d-flex gap-2 align-items-center">
                    <Label htmlFor="name-bar" className="form-label m-0">
                      {t("Content")}
                    </Label>
                    <div>{data?.ratingContent || "-"}</div>
                  </div>
                </Card>
              )}
            </div>
          </div>

          {data?.attachments?.length > 0 && (
            <div className="mb-3">
              <Label htmlFor="name-bar" className="form-label m-0">
                {t("Attachment")}:
              </Label>
              <div className="d-flex gap-3 flex-wrap">
                {data?.attachments?.map((i: any) => {
                  if (
                    i?.type == "video" ||
                    (i?.type == "file" && i?.path?.includes(".mp4"))
                  )
                    return (
                      <video width="160" height="120" controls key={i?.path}>
                        <source src={i?.path} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    );

                  if (i?.type == "image")
                    return (
                      <div>
                        <div
                          style={{ width: "90px" }}
                          className="cursor-pointer"
                          onClick={() => {
                            // if (data?.attachments?.length > 1) {
                            //   setLinkImage({
                            //     urls: data?.attachments?.map((i: any) => {
                            //       return { ...i, url: i?.path };
                            //     }),
                            //     keyword: {
                            //       title: data?.filename,
                            //       keyword: data?.filename,
                            //     },
                            //   });
                            // }
                            setLinkImage(i?.path);
                            document.body.className = "modal-open_img";
                          }}
                        >
                          <img
                            src={i?.path}
                            className="flex-shrink-0 rounded w-100"
                            alt="thumbnail"
                          />
                        </div>
                      </div>
                    );
                  return (
                    <div
                      style={{
                        minWidth: 150,
                        height: 120,
                        background: "#F7F7F7",
                        padding: 20,
                        borderRadius: 6,
                      }}
                    >
                      <a href={i?.path}>{i?.filename}</a>
                    </div>
                  );
                }) || "-"}
              </div>
            </div>
          )}
        </Row>
      </div>

      <ModalPreview
        type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
        isOpen={!!linkImage}
        url={linkImage}
        content={linkImage?.content}
        onClose={() => setLinkImage(null)}
      />

      <ModalMultiPreview
        isOpen={!!linkImage?.urls}
        urls={linkImage?.urls || []}
        content={linkImage?.content}
        onClose={() => setLinkImage(null)}
      />
    </React.Fragment>
  );
};

export default Overview;
